var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 104,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2222 80.8889H161.778V94C161.778 99.5228 157.301 104 151.778 104H56.2222C50.6994 104 46.2222 99.5228 46.2222 94V80.8889Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2222 0H59.3333C64.8562 0 69.3333 4.47715 69.3333 10V80.8889H46.2222V0Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.667 10C138.667 4.47715 143.144 0 148.667 0H161.778V80.8889H138.667V10Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H46.2222V23.1111H10C4.47716 23.1111 0 18.634 0 13.1111V10Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.778 0H198C203.523 0 208 4.47715 208 10V13.1111C208 18.634 203.523 23.1111 198 23.1111H161.778V0Z",
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 104,
    width: 23,
    height: 48,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H198C203.523 0 208 4.47715 208 10V94C208 99.5229 203.523 104 198 104H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/High.435fd8efcd299de45c48b9e7faccf4ba.svg";
export { ForwardRef as ReactComponent };